import styled from 'styled-components'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import ArBaseButton from 'src/components/ArBaseButton/ArBaseButton'
import { media } from 'src/styles/styled-components'
import ArBaseImage from 'src/components/ArBaseImage/ArBaseImage'
import { Link } from 'gatsby'
import ArUnderlinedLink from 'src/components/typography/ArUnderlinedLink'

export const Wrapper = styled.section`
  background-color: ${ ({ theme }) => theme.colors.black };
  color: ${ p => p.theme.colors.white };
  padding: 40px 0;

  ${ media.tablet`
    padding: 60px 0 80px;
  ` }

  ${ media.desktop`
    padding: 100px 0 130px;
  ` }
`

export const Container = styled(ArBaseContainer)`
`

export const Text = styled.div`
  margin: 0 auto 60px;
  max-width: 730px;

  ${ media.tablet`
    max-width: 605px;
    margin-bottom: 77px;
  ` }

  ${ media.desktop`
    margin-bottom: 148px;
  ` }
`

export const Title = styled.h2`
  font-size: 2.8rem;
  font-weight: ${ p => p.theme.fontWeight.primary.Medium };
  line-height: 119.52%;
  text-align: center;

  ${ media.tablet`
    font-size: 3.8rem;
    line-height: 139.44%;
  ` }

  ${ media.desktop`
    font-size: 4.5rem;
  ` }
`

export const Description = styled.p`
  font-size: 2.2rem;
  font-weight: ${ p => p.theme.fontWeight.primary.Light };
  line-height: 1.55;
  margin-top: 20px;
  text-align: center;

  ${ media.tablet`
    font-size: 1.8rem;
    letter-spacing: 0.01em;
    margin-top: 30px;
  ` }

  ${ media.desktop`
    font-size: 2.2rem;
    letter-spacing: normal;
  ` }
`

export const CTA = styled(ArBaseButton)`
  margin: 30px auto 0;
  max-width: 250px;

  ${ media.tablet`
    margin-top: 50px;
  ` }
`

export const Items = styled.div`
  .swiper-wrapper {
    /* align-items: stretch; */
  }

  ._ArSwiper__pagination {
    margin-top: 30px;
  }

  > div {
    margin-top: 50px;

    ${ media.tablet`
      margin-top: 60px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin-bottom: -17px;
    ` }

    ${ media.desktop`
      margin: 0 -10px;
    ` }
  }
`

export const ItemWrapper = styled.div`
  height: auto;

  ${ media.tablet`
    width: 42%;
    margin-bottom: 16px;
    padding: 0 11px;
  ` }

  ${ media.desktop`
    width: 20%;
    padding: 0 10px;
  ` }
`

export const ItemLink = styled.p`
  color: ${ p => p.theme.colors.turquoise };
  display: inline-block;
  font-family: ${ ({ theme }) => theme.font.secondary };
  font-size: 1.4rem;
  font-weight: ${ p => p.theme.fontWeight.secondary.Regular };
  letter-spacing: 0.01em;
  line-height: 2;
  margin-top: 25px;
  text-align: center;
  ${ ArUnderlinedLink }

  ${ media.tablet`
    margin-top: auto;
  ` }

  ${ media.desktop`
    color: ${ p => p.theme.colors.grey2 };
    transition: color .3s ease-out;
  ` }
`

export const Item = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${ p => p.theme.colors.codGray2 };
  box-sizing: border-box;
  /* height: 100%; */
  margin: 0 auto;
  max-width: 270px;
  padding: 50px 30px 45px;

  ${ media.tablet`
    padding: 45px 30px 40px;
    height: 100%;
  ` }

  ${ media.desktop`
    padding: 30px;
    transition: background-color .3s ease-out;

    &:hover {
      background-color: ${ p => p.theme.colors.mineShaft3 };

      ${ ItemLink } {
        color: ${ p => p.theme.colors.turquoise };
      }
    }
  ` }
`

export const ItemImage = styled(ArBaseImage)`
  max-width: 102px;
  width: 100%;

  ${ media.tablet`
    max-width: 100px;
  ` }

  ${ media.desktop`
    max-width: 80px;
  ` }
`

export const ItemTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: ${ p => p.theme.fontWeight.primary.Light };
  line-height: 1.55;
  margin-top: 50px;
  text-align: center;

  ${ media.tablet`
    margin-top: 30px;
    margin-bottom: 15px;
  ` }

  ${ media.desktop`
    font-size: 1.8rem;
  ` }
`
